import { type Asset } from '/@/common/images/types'
import { createModal } from '/@/core/elements/modal'

interface ImageSelectModalData {
  image: Asset
  onSubmit: (imageUrl: string) => void
}

const { api, component } = createModal<ImageSelectModalData>(
  'ImageSelectModal',
  () => import('./ImageSelectModal.vue'),
)

export const useImageSelectModal = api
export default component
